import * as R from 'ramda'

// This makes sure that there is a pending value
const isNotNil = benefit => !R.isNil(benefit.pending)

// This makes sure that the pending and current values are different
const hasBenefitDifference = benefit =>
  !R.equals(benefit.pending, benefit.current)

// Makes sure that the benefit should render,
// by making sure the pending change is not nil
// and that the pending and current values are different
export const shouldRenderBenefit = R.allPass([isNotNil, hasBenefitDifference])
